var React = require('react');

function IconArrowForward (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M133.779 46.0294C143.152 36.6569 158.348 36.6569 167.721 46.0294L248.721 127.029C258.093 136.402 258.093 151.598 248.721 160.971L167.721 241.971C158.348 251.343 143.152 251.343 133.779 241.971C124.407 232.598 124.407 217.402 133.779 208.029L173.809 168H56.25C42.9952 168 32.25 157.255 32.25 144C32.25 130.745 42.9952 120 56.25 120H173.809L133.779 79.9706C124.407 70.598 124.407 55.402 133.779 46.0294Z","fill":"black"}));
}

IconArrowForward.defaultProps = {"width":"288","height":"288","viewBox":"0 0 288 288","fill":"none"};

module.exports = IconArrowForward;

IconArrowForward.default = IconArrowForward;
